import { Box, Container, Typography } from '@mui/material';
import { ArchiveOrganizationManagement } from 'components/templates/ArchiveOrganizationManagement';
import React from 'react';

export const ArchivedOrganizations = () => {
  return (
    <Container component="main" maxWidth="xl" sx={{ width: '75%' }}>
      <Box>
        <Typography variant="h4" component="h1" gutterBottom sx={{ textAlign: 'left' }}>
          Archived Organizations
        </Typography>
      </Box>
      <ArchiveOrganizationManagement />
    </Container>
  );
};
